/**
 * Who sees the clock-in overlay, and whether they can get past it.
 *
 * One hourly worker never clocked himself in — he dismissed the reminder with
 * "Later" every morning and Michel ended up starting his day by hand. So for
 * hourly staff this stopped being a reminder and became a lock.
 *
 * Pulled out of Header.jsx because it decides whether someone can use the app
 * at all: a wrong branch here means nobody hourly can work, and that deserves
 * a truth table rather than a squint at the JSX.
 *
 * Plain CommonJS so a node script can require() it — the frontend has no test
 * runner, and adding one to cover a handful of booleans would cost more than
 * the feature.
 *
 * @returns {{ show: boolean, locked: boolean }}
 *   show   — render the overlay
 *   locked — no way past it: no "Later", tapping outside does nothing
 */
function clockGate({ userType, clockLoaded, clockedIn, clockedOut, currentTab, dismissed }) {
  // Only people who have a clock at all.
  const canClock = userType === 'hourly' || userType === 'office_cleaner';

  // Never before the status has arrived, or the app flashes a lock at someone
  // who clocked in an hour ago.
  const needsClockIn = !!clockLoaded && canClock && !clockedIn && !clockedOut;

  if (!needsClockIn) return { show: false, locked: false };

  if (userType === 'hourly') {
    // Their own invoice stays reachable. They sign it at the weekend, when
    // they are not clocked in and shouldn't be, and blocking it would strand
    // their pay. Everything they'd actually open the app FOR is behind the
    // lock, which is where the pressure needs to be.
    const locked = currentTab !== 'Invoice';
    return { show: locked, locked };
  }

  // The office cleaner does clock herself in; a nudge is enough.
  return { show: !dismissed, locked: false };
}

module.exports = { clockGate };
